/**
 * What the device knows of the account's theme and language before READY
 * (store/look.ts keeps it): read at start by the theme and the language,
 * which come before any store, so a signed-in reload starts in the
 * account's look instead of flashing the console's default first.
 */
import { REFRESH_KEY } from './api/tokens';
import { storage } from './storage';

/** What the account said last about its look (`look-synced`). */
export const LOOK_SYNCED_KEY = 'look-synced';

/** A session is saved on this device: the account's look is the one shown. */
export function hasSavedSession(): boolean {
  return storage.get(REFRESH_KEY) !== null;
}

/** The account's theme, background and language as this device last heard them; empty while signed out. */
export function savedAccountLook(): { theme?: string; background?: string; locale?: string } {
  if (!hasSavedSession()) return {};
  const s = storage.getJson<{ theme?: unknown; background?: unknown; locale?: unknown }>(
    LOOK_SYNCED_KEY,
    {},
  );
  return {
    ...(typeof s?.theme === 'string' ? { theme: s.theme } : {}),
    ...(typeof s?.background === 'string' ? { background: s.background } : {}),
    ...(typeof s?.locale === 'string' ? { locale: s.locale } : {}),
  };
}
